import { Button, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import styles from './index.module.scss';

type RetentionOfferProps = {
  name?: string;
  description?: string | null;
  handleSelect: () => void;
};

const RetentionOffer = ({
  name,
  description,
  handleSelect,
}: RetentionOfferProps) => {
  const { t } = useTranslation('Disconnect');

  return (
    <div className={styles['retentionOffer']}>
      <div className={styles['retentionOfferDetails']}>
        {name && <Txt variant="bodySmallBold">{name}</Txt>}
        {description && <Txt variant="smallRegular">{description}</Txt>}
      </div>
      <Button variant="secondary" onClick={handleSelect}>
        {t('button.select')}
      </Button>
    </div>
  );
};

export default RetentionOffer;
